import { MagnifyingGlass } from "@phosphor-icons/react";
import { openPrybar } from "./spark";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/.test(navigator.platform);

export function HealthOsCommandTrigger() {
  return (
    <button
      type="button"
      onClick={openPrybar}
      aria-label="Open command bar"
      title={`Search or ask HealthOS (${isMac ? "⌘K" : "Ctrl K"})`}
      className="group flex w-full items-center gap-2.5 rounded-md border border-mist-dark/40 bg-white px-2.5 py-2 text-left text-gray-500 transition-colors hover:bg-mist focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
    >
      <MagnifyingGlass
        size={16}
        weight="regular"
        className="shrink-0 text-gray-400 transition-colors group-hover:text-teal-600"
      />
      <span className="min-w-0 flex-1 truncate text-sm tracking-[-0.005em]">Search or ask…</span>
      <kbd className="hidden shrink-0 rounded-sm border border-mist-dark/40 bg-mist/60 px-1.5 py-0.5 font-mono text-xs text-gray-500 group-hover:text-gray-600 sm:inline">
        {isMac ? "⌘K" : "Ctrl K"}
      </kbd>
    </button>
  );
}
